import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Boxes, Package, AlertTriangle } from "lucide-react";

export default function InventoryPage() {
  const [assets, setAssets] = useState([]);
  const [cons, setCons] = useState([]);
  useEffect(() => {
    api.get("/erp/inventory/assets").then((r) => setAssets(r.data.items));
    api.get("/erp/inventory/consumables").then((r) => setCons(r.data.items));
  }, []);
  const lowStock = cons.filter(c => c.stock < c.min_stock * 1.5);
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">Inventory</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Assets & Stores</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPI icon={Boxes} label="Total Assets" value={assets.length}/>
        <KPI icon={Package} label="Consumables" value={cons.length}/>
        <KPI icon={AlertTriangle} label="Low Stock" value={lowStock.length}/>
        <KPI icon={Boxes} label="In Use" value={assets.filter(a=>a.status==="in_use").length}/>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="font-heading font-semibold mb-3">Assets Register</div>
          <div className="overflow-x-auto max-h-96 overflow-y-auto">
            <table className="w-full">
              <thead className="sticky top-0 bg-card z-10">
                <tr>
                  <th className="table-th">Code</th>
                  <th className="table-th">Name</th>
                  <th className="table-th">Assigned</th>
                  <th className="table-th">Status</th>
                </tr>
              </thead>
              <tbody>
                {assets.map(a => (
                  <tr key={a.id} className="border-t border-border">
                    <td className="table-cell font-mono">{a.asset_code}</td>
                    <td className="table-cell">{a.name}</td>
                    <td className="table-cell text-muted-foreground">{a.assigned_to}</td>
                    <td className="table-cell"><span className={`stat-pill capitalize ${a.status === "in_use" ? "bg-emerald-500/10 text-emerald-500" : a.status === "maintenance" ? "bg-amber-500/10 text-amber-500" : "bg-slate-500/10 text-slate-500"}`}>{a.status.replace("_"," ")}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="font-heading font-semibold mb-3">Consumables</div>
          <div className="space-y-2">
            {cons.map((c) => {
              const pct = Math.min(100, (c.stock / (c.min_stock * 3)) * 100);
              const low = c.stock < c.min_stock * 1.5;
              return (
                <div key={c.id} className="rounded-lg border border-border p-3">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-medium">{c.name}</div>
                      <div className="text-xs text-muted-foreground">Min: {c.min_stock} {c.unit}</div>
                    </div>
                    <div className={`text-sm font-heading font-bold ${low ? "text-amber-500" : "text-emerald-500"}`}>{c.stock} <span className="text-xs text-muted-foreground">{c.unit}</span></div>
                  </div>
                  <div className="mt-2 h-1.5 rounded-full bg-muted overflow-hidden">
                    <div className={`h-full ${low ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${pct}%` }}/>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
function KPI({ icon: Icon, label, value }) {
  return (
    <div className="kpi-card">
      <div className="h-10 w-10 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center"><Icon className="h-5 w-5"/></div>
      <div className="mt-3 font-heading text-2xl font-bold">{value}</div>
      <div className="text-xs text-muted-foreground mt-1">{label}</div>
    </div>
  );
}
